import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { FiltersM } from '../../../components/models';
import { formatear, periodos } from '../../funciones/funcionesGenerales';
import moment, { months } from 'moment';
import { typesApex } from '../../../components/models';
import { CookieService } from 'ngx-cookie-service';
import { HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { environment } from '../../../../environments/environment';
import { getActivoInactivos, getConsolidado } from '../../../services/asociatividad-comercial/tendencia/tendenciaQuerys';
import { messages } from '../../funciones/mensajes';
import { GraficasComponent } from '../../../components/graficas/graficas.component';
import Swal from 'sweetalert2';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import { ExcelService } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-tendencia',
  templateUrl: './tendencia.component.html',
  styleUrl: './tendencia.component.css',
})
export class TendenciaComponent {

  @ViewChildren(GraficasComponent) grafComp!: QueryList<GraficasComponent>;

  private pdfFile: any;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  types = typesApex;
  maxPeriods = 12;
  subtitles1 = '';
  subtitles2 = '';
  // Valores para generar la gráfica 1
  tituloZona1 = '';
  data1 = [];
  labels1 = [];
  axisY1 = [];
  reset1 = false;
  graphics1 = [typesApex.AREA, typesApex.BAR, typesApex.COMBO, typesApex.LINE, typesApex.STACKED, typesApex.TABLE];
  zona1 = 1;
  perspectives = [];
  // Valores para generar la gráfica 2
  tituloZona2 = '';
  data2 = [];
  labels2 = [];
  axisY2 = [];
  reset2 = false;
  graphics2 = [typesApex.AREA, typesApex.BAR, typesApex.DONUT, typesApex.TABLE, typesApex.FUNNEL];
  zona2 = 2;
  // Valores para generar la gráfica 2
  tituloZona3 = '';
  data3 = [];
  labels3 = [];
  axisY3 = [];
  reset3 = false;
  graphics3 = [typesApex.COMBO, typesApex.AREA, typesApex.BAR, typesApex.TABLE];
  zona3 = 3;
  // Variables Filtros
  Filters = FiltersM;
  yearsAvailable = [];
  monthAvailable = [];
  monthSelect = false;

  periodicidad = [
    {name: 'Mensual', check: true, value: 1},
    {name: 'Bimestral', check: false, value: 2},
    {name: 'Semestral', check: false, value: 6},
    {name: 'Anual', check: false, value: 12},
  ];

  sucursales = [];
  consolidado = true;

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    private cookieService: CookieService,
    private apollo: Apollo,
    private excel: ExcelService,
  ) {
    formatear.momentAbrev();
    this.getPeriods();
  }

  private getPeriods(){
    for(var i = 0; i<10; i++){
      this.sucursales.push({
        name: `Sucursal-${i+1}`,
        check: false
      });
    }
    const start = moment('2023-01-01');
    const end = moment('2025-05-01');
    var auxYear = [], auxMounts = [], year = undefined;
    while(start.isSameOrBefore(end)){
      const exYear = auxYear.find(y => y.anio === start.year());
      if(!exYear){
        year = start.year();
        auxYear.push({
          anio: start.year(),
          name: start.year()+'',
          check: false,
          visible: true,
          utilizable: true,
        });
      }
      auxMounts.push({
        mes: start.format('MMM').toLowerCase(),
        mesS: start.format('MMMM').toLowerCase(),
        check: false,
        an: start.year(),
        anio: start.format('YY'),
        periodo: start.format('MMM-YY').toLowerCase(),
        visible: true,
        utilizable: true,
      });
      start.add(1, 'month');
    }

    this.monthAvailable = auxMounts;
    this.yearsAvailable = auxYear;
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;

    this.tituloZona1 = 'Consolidado';
    this.tituloZona2 = 'Inactividad';
    this.tituloZona3 = 'Altas / bajas';
    this.getData();
  }
  public resetFilters(){
    this.reset1 = true;
    this.reset2 = true;
    this.reset3 = true;
    setTimeout(() =>{
      this.reset1 = false;
      this.reset2 = false;
      this.reset3 = false;
    },10);

    this.monthSelect = false;

    for(const month of this.monthAvailable){
      month.check = false;
    }

    for(const suc of this.sucursales){
      suc.check = false;
    }
    this.consolidado = true;

    for(const per of this.periodicidad){
      per.name.toLowerCase() === 'mensual' ? per.check = true: per.check = false;
    }
    for(const an of this.yearsAvailable){
      if (an === this.yearsAvailable[this.yearsAvailable.length - 1]) {
        an.check = true;
      }else{
        an.check = false;
      }
    }

    this.getData();
  }
  //Consultas para obtener información
  private validatePeriodiciti(pos, mes){
    const peri = this.periodicidad.find(el => el.check === true);
    const monts = this.monthAvailable.filter(m => m.an === mes.an);
    if(peri.name.toLowerCase() === 'anual' && monts[monts.length-1].periodo === mes.periodo){
      return true;
    }else if (peri.name.toLowerCase() !== 'anual' && pos%peri.value === 0){
      return true;
    }
    return false;
  }
  private async getData(){
    this.data1 = [];
    this.data2 = [];
    this.data3 = [];

    this.labels1 = [];
    this.labels2 = [];
    this.labels3 = [];
    
    this.axisY1 = [];
    //Zona 1
    var auxData1Series1 = [], auxData1Series2 = [];
    var pos = 0;
    var yearSelect = this.yearsAvailable.find(y => y.check === true);
    const arreglo = [...this.monthAvailable].reverse();
    for(const mes of arreglo){
      if( (mes.an === yearSelect.anio && auxData1Series1.length === 0) || ( auxData1Series1.length > 0 && auxData1Series1.length < this.maxPeriods && this.validatePeriodiciti(pos, mes))){
        try{
          // const { data } = await firstValueFrom(
          //   this.apollo.use(environment.api_comercial).watchQuery<any>({
          //     query: getConsolidado,
          //     context: { headers: this.headers },
          //     variables: {
          //       period: `${moment(mes.periodo, 'MMM-YY').format('YYYY-MM')}-31`,
          //       year: mes.an,
          //       institutionId: 1
          //     },
          //     fetchPolicy: 'no-cache'
          //   }).valueChanges
          // );
          // if(data.ConsolidadoSocios.length !== 0){
          //   const v = data.ConsolidadoSocios[0]
          //   auxData1Series1.push(v.totalPartners);
          //   auxData1Series2.push(v.growth==='null'?v.growth:10)
          // }else{
            var max = 15800, min = 15000;
            auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(0)) );
            // auxData1Series1.push(auxData1Series1[0]-(auxData1Series1[0]*.10));
            auxData1Series2.push(200)
          // }
          this.labels1.push(mes.periodo);
        }catch(error){
          messages.errorMessageGraph(error);
        }
      }
      if(auxData1Series1.length !== 0){
        pos++;
      }
    }
    this.labels1.reverse();
    this.data1 = [
      {
        name: 'serie-1',
        data: auxData1Series1.reverse()
      },{
        name: 'serie-2',
        data: auxData1Series2.reverse()
      }
    ];
    this.axisY1.push('serie-1', 'serie-2');
    // Zona 2
    const month = this.monthAvailable.filter( m => m.an === yearSelect.anio);
    const mes = month[month.length -1];
    // const { data } = await firstValueFrom(
    //   this.apollo.use(environment.api_comercial).watchQuery<any>({
    //     query: getActivoInactivos,
    //     context: { headers: this.headers },
    //     variables: {
    //       period: `${moment(mes.periodo, 'MMM-YY').format('YYYY-MM')}-31`,
    //       year: mes.an,
    //       institutionId: 1
    //     },
    //     fetchPolicy: 'no-cache'
    //   }).valueChanges
    // );
    // const v = data.actividadSocios[0];
    auxData1Series1 = [];
    // auxData1Series1 = [ v.activeCount, v.inactiveCount];

    for(var i = 0; i<2; i++){
      var max = 15, min = 5;
      auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
    }
    this.labels2 = ['Activo', 'Inactivo'];
    this.data2 = [{
      name: 'Activo',
      data: auxData1Series1
    }];
    this.axisY2 = ['Inactividad'];
    // Zona 3
    auxData1Series1 = [];
    auxData1Series2 = [];
    var auxData1Series3 = [];
    for(var i = 0; i<7; i++){
      var max = 15, min = 5;
      auxData1Series1.push( 5 );
      auxData1Series2.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      auxData1Series3.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      this.labels3.push(`S${i+1}`);
    }

    this.data3 = [{
      name: 'serie-1',
      data: auxData1Series2
    },{
      name: 'serie-2',
      data: auxData1Series3
    },{
      name: 'serie-3',
      data: auxData1Series1
    }];
    this.axisY3 = ['serie-1']
    this.generateSubtitles();
  }

  private async generateSubtitles(){
    this.subtitles1 = '';
    this.subtitles2 = '';
    var pos = 0;
    var labels = 0;
    const peri = this.periodicidad.find(el => el.check === true);
    var yearSelect = this.yearsAvailable.find(y => y.check === true);
    var monthSelect = this.monthAvailable.find(m => m.check === true);
    if(!monthSelect){
      [...this.monthAvailable].reverse().forEach(mes =>{
        const an = this.subtitles1.split(' | ');
        const ex = an.find( a => Number(a) === Number((mes.an+'').substring(2,4)) );
        if( !ex && (mes.an === yearSelect.anio || (pos%peri.value === 0 && labels < this.maxPeriods)) ){
          this.subtitles1 += `${(mes.an+'').substring(2,4)} | `;
          labels++;
        }
        if(labels !== 0){
          pos++;
        }
      });

      this.subtitles2 = '';
      this.subtitles2 = yearSelect.name.substring(2,4);
      this.subtitles1 = this.subtitles1.substring(0, this.subtitles1.length-3);
    }else{
      this.subtitles1 = monthSelect.periodo;
      this.subtitles2 = monthSelect.periodo;
    }
    if(this.consolidado){
      const traduccion = await firstValueFrom(
        this.translate.get('filtros.consolidado')
      );
      this.subtitles1 += ` | ${traduccion}`;
      this.subtitles2 += ` | ${traduccion}`;
    }else{
      for(const suc of this.sucursales){
        if(suc.check){
          this.subtitles1 += ` | ${suc.name}`;
          this.subtitles2 += ` | ${suc.name}`;
        }
      }
    }
  }

  clickGraphicPrincipal(event){
    if(this.perspectives.length === 0){
      for(var i=0; i<8; i++){
        this.perspectives.push({
          name: `Perspective ${i+1}`,
          id: i
        });
      }
    }
    this.monthAvailable.forEach( m =>{
      if(m.periodo === event.name){
        m.check = true;
      }else{
        m.check = false;
      }
    });
    this.monthSelect = true;
    this.generateSubtitles(); 
  }

  clickGraphicFilter(clicked: any) {
  }
  periodicityChange(event: any) {
    this.periodicidad.forEach( p => {
      if(p.value === event.value){
        p.check = true;
      }else{
        p.check = false;
      }
    });
    this.getData();
  }
  yearChange(year: object): void {
    this.yearsAvailable.forEach( y => {
      if(year['name'] === y.name){
        y.check = true;
      }else{
        y.check = false;
      }
    });
    this.getData();
  }
  sucursalChange(sucClick){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = true;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }
  exportarSucursales(){
    
  }
  //Exportación de PDF All
  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          await this.generateZonaPDF(this.zona1),
          await this.generateZonaPDF(this.zona2),
          await this.generateZonaPDF(this.zona3),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  async generateZonaPDF(zonaE){
    const comp = this.grafComp.find(g => g.zona === zonaE);
    var img = undefined;
    var table = undefined;
    if(comp.type !== typesApex.TABLE){
      img = await comp.exportImgBlob();
    }
    table = await comp.exportTablePDF();

    var cont = [
      comp.exportTitles(),
      // table !== undefined ? {
      //   text: 'Tabla'
      // } : { text: '' },
      table !== undefined ? table : { text: '' },
      // img !== undefined ? {
      //   text: 'Gráfica'
      // } : { text: '' },
      img !== undefined ? img : { text: '' }
    ];
    return cont;
  }
}
